export default "__VITE_ASSET__CAa5YU7S__"